import {useTranslation} from 'react-i18next';
import {getRegExpFromString} from '@guestapp/core';
import {AddFormV2Type, AddFormType} from 'context/guest';
import {isRequiredFormField} from '@guestapp/sdk';
import {FORM_NAMES} from 'utils/guestForm';
import {type FormFieldsMapper} from './types';

type Props = {
  formFieldsMapper: FormFieldsMapper;
  fieldName: FORM_NAMES;
  formFields: AddFormV2Type | AddFormType;
};
export const DefaultField = ({formFieldsMapper, fieldName, formFields}: Props) => {
  const {t} = useTranslation();
  const format = getRegExpFromString(formFields?.[fieldName]?.format || '');
  const required = isRequiredFormField(formFields?.[fieldName])
    ? t('this_field_is_required')
    : false;

  return formFieldsMapper[fieldName]?.({required, format});
};
